//薪酬发放
import { $http, buildHeaders } from "./index";

//获取外协工资发放列表
export const salarypayment_list = (params) => {
  return $http.get("/admin/SalaryPayment/index", { params });
};

//手动发放
export const salarypayment_manualpay = (data) => {
  return $http.post("/admin/SalaryPayment/manualPay", data, {
    headers: buildHeaders(3),
  });
};

//银企发放
export const salarypayment_b2epay = (data) => {
  return $http.post("/admin/SalaryPayment/b2ePay", data, {
    headers: buildHeaders(3),
  });
};

//开始发放
export const salarypayment_startpay = (data) => {
  return $http.post("/admin/SalaryPayment/startPay", data, {
    headers: buildHeaders(3),
  });
};

//撤回发放
export const salarypayment_cancelpay = (data) => {
  return $http.post("/admin/SalaryPayment/cancelPay", data, {
    headers: buildHeaders(3),
  });
};

//获取外协工资发放详情
export const salarypayment_detail = (id) => {
  return $http.get("/admin/SalaryPayment/read?id=" + id, {
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取发薪单明细
export const salarypayment_record = (params) => {
  return $http.get("/admin/SalaryPayment/detail", { params });
};

//获取发薪单操作日志
export const salarypayment_log = (params) => {
  return $http.get("/admin/SalaryPayment/log", { params });
};

//上传薪酬发放电子回单文件
export const salarypayment_log_upload = (data) => {
  return $http.post("/admin/SalaryPayment/uploadSftpFile", data, {
    headers: buildHeaders(3),
  });
};

//下载发薪单电子回单
export const salarypayment_log_donwload = (params) => {
  return $http.get("/admin/SalaryPayment/downloadSftpFile", {
    params,
    responseType: "blob",
    headers: buildHeaders(1, "正在下载文件，请稍后……"),
  });
};

//删除电子回单
export const salarypayment_delsftpfile = (data) => {
  return $http.post("/admin/SalaryPayment/delSftpFile", data, {
    headers: buildHeaders(3),
  });
};

//标记发放失败
export const salarypayment_setfailure = (data) => {
  return $http.post("/admin/SalaryPayment/setFailure", data, {
    headers: buildHeaders(3),
  });
};

//标记已发放
export const salarypayment_setdone = (data) => {
  return $http.post("/admin/SalaryPayment/setDone", data, {
    headers: buildHeaders(3),
  });
};

//调用银企接口发放
export const salarypayment_do = (data) => {
  return $http.post("/admin/SalaryPayment/do", data, {
    headers: buildHeaders(3),
  });
};

//导出
export const salarypayment_export = (params) => {
  return $http.get("/admin/SalaryPayment/export", {
    params,
    responseType: "blob",
    headers: buildHeaders(1, "正在下载文件，请稍后……"),
  });
};
